import { Injectable, inject } from '@angular/core';
import { ContactUsService } from '@eview/core/services/contact-us.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    ContactUsFailure,
    ContactUsPost, ContactUsSuccess, EContactUsActions
} from '../actions/contact-us.actions';

@Injectable()
export class ContactUsEffects {
    constructor(private contactUsService: ContactUsService) {}

  private readonly actions$ = inject(Actions);

    contactUs$ = createEffect(() =>
        this.actions$.pipe(
            ofType<ContactUsPost>(EContactUsActions.ContactUsPost),
            map(action => action.payload),
            switchMap(payload =>
                this.contactUsService.contactUsRequest(payload).pipe(
                    map(user => (user ? new ContactUsSuccess() : new ContactUsFailure())),
                    catchError(() => of(new ContactUsFailure()))
                )
            )
        )
    );
}
